import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["duration", "delay", "icons", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useImperativeHandle, useRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import { useLogoCarousel } from './useLogoCarousel';
import { ICON_HEIGHT } from './constants';
import * as views from './LogoTrack.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var SECOND = 1000;
var DEFAULT_DURATION = 3 * SECOND;
var DEFAULT_DELAY = 0.2 * SECOND;
var GAP = 40;
var MAX_ICON_WIDTH = 120;

var getNormalizedIconWidth = function getNormalizedIconWidth(_ref) {
  var width = _ref.width,
      height = _ref.height;
  var unboundedWidth = Math.round(width / height * ICON_HEIGHT);
  /*
    We want the width of the icon to be an even number so that we can safely divide it by 2
    when calculation animation step width (in `getAnimationStepWidth` function).
    This makes sure we avoid sub-pixel rendering.
  */

  var widthRoundedNearestToEven = Math.round(unboundedWidth / 2) * 2;
  return Math.min(widthRoundedNearestToEven, MAX_ICON_WIDTH);
};

var getAnimationStepWidth = function getAnimationStepWidth(currentIconWidth, nextIconWidth, gap) {
  return currentIconWidth / 2 + gap + nextIconWidth / 2;
};

var Icon = function Icon(_ref2) {
  var id = _ref2.id,
      IconComponent = _ref2.icon,
      width = _ref2.width,
      height = _ref2.height;
  return _jsx(views.IconWrapper, {
    width: getNormalizedIconWidth({
      width: width,
      height: height
    }),
    height: ICON_HEIGHT,
    children: _jsx(IconComponent, {})
  }, id);
};

var easing = [0.75, 0, 0.36, 0.99];
var BaseLogoTrack = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? DEFAULT_DURATION : _ref3$duration,
      _ref3$delay = _ref3.delay,
      delay = _ref3$delay === void 0 ? DEFAULT_DELAY : _ref3$delay,
      icons = _ref3.icons,
      tokens = _ref3.tokens,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var carouselRef = useRef(null);
  useImperativeHandle(ref, function () {
    return carouselRef.current;
  });

  var _useLogoCarousel = useLogoCarousel({
    icons: icons,
    delay: delay,
    duration: duration
  }),
      prevIcons = _useLogoCarousel.prevIcons,
      currentIcon = _useLogoCarousel.currentIcon,
      nextIcons = _useLogoCarousel.nextIcons,
      currentIndex = _useLogoCarousel.currentIndex,
      animation = _useLogoCarousel.animation;

  var currentIconWidth = getNormalizedIconWidth(currentIcon);
  var nextIcon = nextIcons[0];
  var nextIconWidth = getNormalizedIconWidth(nextIcon);
  return _jsx(views.LogoTrack, _objectSpread(_objectSpread({
    ref: carouselRef
  }, rest), {}, {
    color: tokens.color,
    children: _jsxs(views.SlotWrapper, {
      animate: animation,
      transition: {
        x: {
          ease: easing,
          duration: duration / SECOND
        }
      },
      variants: {
        toLeft: {
          x: "-".concat(getAnimationStepWidth(currentIconWidth, nextIconWidth, tokens.gap), "px")
        }
      },
      gap: tokens.gap,
      children: [_jsx(views.LeftSlot, {
        gap: tokens.gap,
        children: prevIcons.map(function (icon) {
          return _jsx(Icon, _objectSpread({}, icon), icon.id);
        })
      }), _jsx(views.MiddleSlot, {
        children: _jsx(Icon, _objectSpread({}, currentIcon))
      }), _jsx(views.RightSlot, {
        gap: tokens.gap,
        children: nextIcons.map(function (icon) {
          return _jsx(Icon, _objectSpread({}, icon), icon.id);
        })
      })]
    }, currentIndex)
  }));
});
export var LogoTrack = withDesignTokens(BaseLogoTrack, function () {
  return {
    gap: GAP
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  }
});